import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "./Menu"
import { toogleDrawer } from "../actions/authActions";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ContactsRoundedIcon from "@material-ui/icons/ContactsRounded";
import StoreRoundedIcon from "@material-ui/icons/StoreRounded";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import { NavLink } from "react-router-dom";
import Masonry from "react-masonry-css";
import CheckIcon from "@material-ui/icons/Check";
import { withStyles } from "@material-ui/core/styles";
import { purple } from "@material-ui/core/colors";
import Switch from "@material-ui/core/Switch";
import { connect } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { removeWishlist } from "../actions/wishlistActions";
import Paper from "@material-ui/core/Paper";
import {
    setThemeDark,
    setThemeLight,
    toggletheme,
} from "../actions/mainAction";
import NotInterestedOutlinedIcon from "@material-ui/icons/NotInterestedOutlined";
import "./Styles.css";
import {
    Grid,
    Card,
    CardMedia,
    CardActionArea,
    CardContent,
    TextField,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    InputAdornment,
    Box,
} from "@material-ui/core";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import RemoveShoppingCartRoundedIcon from "@material-ui/icons/RemoveShoppingCartRounded";
import PostItem from "./PostItem";
import ShowMoreText from "react-show-more-text";
import StarsIcon from "@material-ui/icons/Stars";
import { getPostScroll } from "../actions/productActions";
import Footer from "./Footer";
const drawerWidth = 240;
const breakpointColumnsObj = {
    default: 4,
    1300: 3,
    950: 2,
    650: 1,
};
const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        "&$checked": {
            transform: "translateX(16px)",
            color: theme.palette.common.white,
            "& + $track": {
                backgroundColor: "#52d869",
                opacity: 1,
                border: "none",
            },
        },
        "&$focusVisible $thumb": {
            color: "#52d869",
            border: "6px solid #fff",
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const useStyles = makeStyles((theme) => ({
    root: {
        // display: "flex",
    },
    nav: {
        textDecoration: "none",
        color: "inherit",
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {

    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 160,
    },

    menuButton: {
        marginRight: theme.spacing(2),

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),

    },
    root: {
        marginBottom: "3rem",
        padding: "1px",
        borderRadius: "0.5rem",
        maxWidth: 345,
        margin: "auto",
        transition: "0.3s",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)",
        },
    },
    media: {
        height: "250px",
        width: "94%",
        maxWidth: "400px",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        margin: "9px",
    },
    table: {
        // minWidth: auto,
    },
}));


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const rows = [
    createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
    createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
    createData("Eclair", 262, 16.0, 24, 6.0),
    createData("Cupcake", 305, 3.7, 67, 4.3),
    createData("Gingerbread", 356, 16.0, 49, 3.9),
];

function Home(props) {
    const [Products, setProducts] = useState([]);
    const [page, setpage] = useState(2);
    const [hasmore, sethasmore] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [Switch, setSwitch] = useState(false);
    const [ButtonLoading, setButtonLoading] = useState(false);
    const [filter, setfilter] = useState([]);
    const [filterCondition, setfilterCondition] = useState("");
    const [subData, setsubData] = useState("");
    // let filter = [];
    const [SubCats, setSubCats] = useState([]);

    console.log(SubCats, "subs");
    console.log(filter);
    if (props.Button) console.log(Products, "pro");
    useEffect(() => {
        // props.getPostScroll(1);
    }, []);
    const loadMore = () => {
        setpage(page + 1);
        setButtonLoading(true);
        props.getPostScroll(page);
    };

    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);
    console.log(props.main.theme, "theme");
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const [search, setSearch] = React.useState("");
    let FilteredPosts = props.wishlist.wishproducts;
    const drawer = (
        <div>
            <div className={classes.toolbar} />
            <Divider />
            <List>
                <NavLink to="/" className={classes.nav}>
                    <ListItem>
                        <ListItemIcon>
                            <HomeRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Home"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/shop" className={classes.nav}>
                    <ListItem button button>
                        <ListItemIcon>
                            <StoreRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Shop"} />
                    </ListItem>
                </NavLink>
                {props.auth.isAuthenticated ? (
                    <NavLink to="/cart" className={classes.nav}>
                        <ListItem button>
                            <ListItemIcon>
                                <ShoppingCartRoundedIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Cart"} />
                        </ListItem>
                    </NavLink>
                ) : null}
                {props.auth.isAuthenticated ? (
                    <NavLink to="/wishlist" className={classes.nav}>
                        <ListItem button selected={true}>
                            <ListItemIcon>
                                <StarsIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Wishlist"} />
                        </ListItem>
                    </NavLink>
                ) : null}

                <NavLink to="/contact" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <ContactsRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Contact Us"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/about" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <InfoRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"About Us"} />
                    </ListItem>
                </NavLink>

                <ListItem button>
                    <ListItemIcon>
                        <IOSSwitch
                            checked={props.main.theme == "dark"}
                            onChange={() => {
                                props.toggletheme();
                            }}
                            name="checkedB"
                        />
                    </ListItemIcon>
                    <ListItemText primary={"Dark Mode"} />
                </ListItem>
            </List>
        </div>
    );

    const container =
        window !== undefined ? () => window().document.body : undefined;

    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={() => {
                            props.toogleDrawer()
                        }}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        align="center"
                        // noWrap
                        style={{
                            fontFamily: " 'Berkshire Swash', cursive",
                            // border: "1px solid",
                            width: "100%",
                        }}
                    >
                        {props.website.website
                            ? props.website.website.header
                            : ""}
                    </Typography>
                </Toolbar>
            </AppBar>

            <Menu />
            <main className={classes.content}>
                <div className={classes.toolbar} />

                {Loading ? (
                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        style={{ marginTop: "10rem" }}
                    >
                        <CircularProgress color="primary" size={80} />
                    </Grid>
                ) : (
                        <>
                            {/* {Products.map((post) => (
                            <PostItem key={post._id} post={post} />
                        ))} */}
                            {FilteredPosts.length > 0 ? (
                                <TableContainer component={Paper}>
                                    <Table
                                        className={classes.table}
                                        aria-label="customized table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>
                                                    Image
                                            </StyledTableCell>
                                                <StyledTableCell align="right">
                                                    Product Name
                                            </StyledTableCell>
                                                <StyledTableCell align="right">
                                                    Price
                                            </StyledTableCell>
                                                <StyledTableCell align="right">
                                                    Remove
                                            </StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {FilteredPosts.map((row) => (
                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <img
                                                            src={row.image1}
                                                            width="35"
                                                            height="35"
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right">
                                                        {row.pname}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right">
                                                        {row.price}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="right">
                                                        <Button
                                                            style={{
                                                                width: "1px",
                                                                fontSize: "10px",
                                                            }}
                                                            size="small"
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={() =>
                                                                props.removeWishlist(
                                                                    row._id
                                                                )
                                                            }
                                                        >
                                                            Remove
                                                    </Button>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                    <Grid
                                        container
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Box
                                            style={{ width: "20rem", height: "20rem" }}
                                        >
                                            <Grid
                                                container
                                                justify="center"
                                                alignItems="center"
                                                style={{ marginTop: "3rem" }}
                                            >
                                                <Grid item xs={12}>
                                                    <Grid
                                                        container
                                                        justify="center"
                                                        alignItems="center"
                                                    >
                                                        <NotInterestedOutlinedIcon
                                                            color="primary"
                                                            style={{ fontSize: "7rem" }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid
                                                        container
                                                        justify="center"
                                                        alignItems="center"
                                                    >
                                                        {" "}
                                                        <Typography>
                                                            Your wishList is empty
                                                </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                )}
                        </>
                    )}
            </main>
            <Footer />
        </div>
    );
}
const mapStateToProps = (state) => ({
    main: state.main,
    wishlist: state.wishlist,
    website: state.website,
    auth: state.auth,
});
export default connect(mapStateToProps, {
    setThemeDark,
    setThemeLight,
    toggletheme,
    getPostScroll,
    removeWishlist,
    toogleDrawer
})(Home);
